<template>
  <div
      class="g-news-info top-nav"
      id="canhui"
      v-if="extras.canhui.display === 1"
  >
    <div class="g-news-content u-w1200">
      <Title
          v-if="extras.canhuiTitle.display === 1"
          :title="extras.canhuiTitle.model || title"
      />
      <div
          class="m-tab-list swiper-list"
          v-if="columns.length > 1 || (columns.length == 1 && columns[0].id != 0)"
      >
        <!--大于1必显示，只有一个目录的时候不是主目录也要显示-->
        <div class="swiper-container swiper1">
          <div class="swiper-wrapper btnevent">
            <div
                class="tab gu-width swiper-slide u-mr26"
                v-for="(item, index) in columns"
                :key="index"
                :class="{
                'tab-active': index == currentId,
                'cursor-default': isSetting == 1,
              }"
                @click="columnClick(item, index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <ul class="g-news-list" v-if="articles && articles.length > 0">
        <li
            class="g-list-info pull-left"
            v-for="(item, i) in articles"
            :key="i"
            :style="{
            display: isShowMore == false && i > 3 ? 'none' : '',
          }"
        >
          <div class="g-list-left pull-left u-mr15">
            <img
                :src="
                item.coverImageRealPath
                  ? item.coverImageRealPath
                  : require('@/assets/images/defaultNew.jpg')
              "
                v-if="extras.cover.display == 1"
            />
          </div>
          <div class="g-list-right pull-left">
            <a
                class="top"
                target="_blank"
                v-if="extras.contentTitle.display == 1 && item.useLinkUrl == 1"
                :href="item.linkUrl"
            >{{ item.name }}</a
            >
            <a
                class="top"
                target="_blank"
                v-if="extras.contentTitle.display == 1 && item.useLinkUrl != 1"
                :href="item.shortUrl"
            >{{ item.name }}</a
            >
            <div class="bottom pull-left" v-if="extras.summary.display == 1">
              {{ item.desc }}
            </div>
            <div class="time1" v-if="extras.sendTime.display == 1">
              {{ item.createTime ? item.createTime.substr(0, 10) : "" }}
            </div>
          </div>
        </li>
      </ul>
      <div class="m-nodata-body" v-if="articles && articles.length == 0">
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">暂无数据</div>
      </div>
      <div class="g-news-bottom" v-if="articles.length > 4">
        <div
            class="g-more-news"
            :class="{
            'g-more-news': !isShowMore,
            'g-more-news-up': isShowMore,
            'cursor-default': isSetting == 1,
          }"
            @click="showMoreArticle"
        >
          更多信息
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    Title,
  },
  props: {
    newsInfo: Object,
    extras: Object,
  },
  data() {
    return {
      title: "新闻资讯",
      currentId: 0,
      columns: [],
      isSetting: 0,
      articles: [],
      moreClass: "max",
      isShowMore: false,
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    //this.initColumns();
    let tempColumns = this.getColumns.articleInitColumns(
        this.newsInfo.column,
        this.newsInfo.article,
        "热门资讯",
        true
    );
    this.columns = tempColumns;
    this.articles = this.columns.length > 0 ? this.columns[0].article : [];
    //    this.currentId = this.columns[0].id;
  },
  methods: {
    columnClick(item, idx) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = idx;
      this.articles = item.article;
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style scoped></style>
